<template>
  <!-- แถบเตือนระบบตรวจสลิป (Convinapp): เครดิตหมด / ใกล้หมด / บัญชีใช้ไม่ได้ / ยังไม่ตั้งค่า -->
  <div v-if="alert" class="alert d-flex align-items-start rounded-lg text-xs-1/2 py-2 px-3 mb-3"
    :class="alert.level === 'danger' ? 'alert-danger' : 'alert-warning'">
    <i class="mdi mdi-alert mr-2"></i>
    <div>
      {{ alert.message }}
      <span v-if="alert.remaining != null && alert.max != null" class="text-gray-600">
        (คงเหลือ {{ alert.remaining.toLocaleString() }} / {{ alert.max.toLocaleString() }} ครั้ง)
      </span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'SlipVerifyAlert',
  data() {
    return { alert: null }
  },
  async mounted() {
    try {
      const res = await Vue.prototype.$axios.get(`${Vue.prototype.$host}/api/v1/slip-verify/status`)
      this.alert = (res.data && res.data.alert) || null
    } catch (e) {
      // ไม่มีสิทธิ์ / เรียกไม่ได้ ไม่ต้องโชว์อะไร
      this.alert = null
    }
  },
}
</script>
